import * as React from "react";
import Box from "@mui/material/Box";
import WindPlot from "../wind";
import WeatherPlot from "../weather";
import PressurePlot from "../pressure";
import { a11yProps, CustomTabPanel, getStationData } from "../util";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";


export default function Neuenburgersee ({ forecast }) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let [vmax_sbl, speed_sbl, dir_sbl, t2m_sbl, precip_sbl, dursun_sbl, twater_sbl, qff_sbl] = getStationData(forecast, "SBL", "neuchatel", "QFF_KLO_GVE");
  let [vmax_por, speed_por, dir_por, t2m_por, precip_por, dursun_por, twater_por, qff_por] = getStationData(forecast, "POR", "neuchatel", "QFF_KLO_GVE");
  let [vmax_yvo, speed_yvo, dir_yvo, t2m_yvo, precip_yvo, dursun_yvo, twater_yvo, qff_yvo] = getStationData(forecast, "YVO", "neuchatel", "QFF_KLO_GVE");

  return (
    <div>
      <title>Neuenburgersee Windvorhersage - Surfwetter</title>
      <div className="App">
        <div className="Content">
          <h2>Neuenburgersee</h2>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs value={value} onChange={handleChange} aria-label="tabs" variant="fullWidth">
                <Tab label="St-Blaise" {...a11yProps(0)} />
                <Tab label="Delley-Portalban" {...a11yProps(1)} />
                <Tab label="Yvonand" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Box sx={{ overflow: "auto" }}>
                <WindPlot vmax={vmax_sbl} speed={speed_sbl} dir={dir_sbl} />
                <PressurePlot qff={qff_sbl} label="Zürich − Genf" label_plus="Bise" label_minus="Westwind" />
                <WeatherPlot t2m={t2m_sbl} precip={precip_sbl} sun={dursun_sbl} twater={twater_sbl} />
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Box sx={{ overflow: "auto" }}>
                <WindPlot vmax={vmax_por} speed={speed_por} dir={dir_por} />
                <PressurePlot qff={qff_por} label="Zürich − Genf" label_plus="Bise" label_minus="Westwind" />
                <WeatherPlot t2m={t2m_por} precip={precip_por} sun={dursun_por} twater={twater_por} />
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <Box sx={{ overflow: "auto" }}>
                <WindPlot vmax={vmax_yvo} speed={speed_yvo} dir={dir_yvo} />
                <PressurePlot qff={qff_yvo} label="Zürich − Genf" label_plus="Bise" label_minus="Westwind" />
                <WeatherPlot t2m={t2m_yvo} precip={precip_yvo} sun={dursun_yvo} twater={twater_yvo} />
              </Box>
            </CustomTabPanel>
          </Box>
        </div>
      </div>
    </div>
  );
};
